<template>
  <div class="hl-repair">
    <h2 class="title">线上报修单</h2>

    <div class="type-row" @click="showTypeSheet = true">
      <span class="label">报修类型</span>
      <div class="type-value">
        <span :class="{ placeholder: !repairTypeLabel }">{{ repairTypeLabel || '请选择' }}</span>
        <span class="arrow">▾</span>
      </div>
    </div>

    <van-action-sheet
      v-model="showTypeSheet"
      :actions="typeActions"
      cancel-text="取消"
      @select="onSelectType"
    />

    <textarea
      v-model="description"
      class="desc"
      rows="5"
      placeholder="请将问题描述一下，我们将尽快为您解决，如能附图为佳"
    />

    <div class="images">
      <div
        v-for="(img, index) in images"
        :key="img.key"
        class="thumb"
      >
        <img :src="img.url" alt="" />
        <span class="remove" @click="removeImage(index)">×</span>
      </div>
      <div
        v-if="images.length < maxImages"
        class="add-btn"
        @click="triggerPick"
      >
        <span class="cam">📷</span>
        <span>拍照/相册</span>
      </div>
      <input
        ref="fileInput"
        type="file"
        accept="image/*"
        multiple
        style="display: none"
        @change="onFilesChange"
      />
    </div>

    <van-button
      type="info"
      block
      class="submit"
      :loading="submitting"
      @click="onSubmit"
    >
      确认提交
    </van-button>
  </div>
</template>

<script>
import { Toast } from 'vant';

// 与接口 type 一致：1 扇五金问题 / 2 玻璃问题 / 3 漏水 / 4 其他
const TYPE_OPTIONS = [
  { name: '扇五金问题', value: 1 },
  { name: '玻璃问题', value: 2 },
  { name: '漏水', value: 3 },
  { name: '其他', value: 4 }
];

export default {
  name: 'hl-repair',
  data() {
    return {
      repairType: TYPE_OPTIONS[0].value,
      description: '',
      images: [],
      showTypeSheet: false,
      maxImages: 5,
      submitting: false,
      typeActions: TYPE_OPTIONS.map(({ name, value }) => ({ name, value }))
    };
  },
  computed: {
    repairTypeLabel() {
      const found = TYPE_OPTIONS.find(t => t.value === this.repairType);
      return found ? found.name : '';
    },
    subCode() {
      return this.$route.query.id || this.$route.query.code || '';
    }
  },
  beforeDestroy() {
    this.images.forEach(img => {
      if (img.localUrl) URL.revokeObjectURL(img.localUrl);
    });
  },
  methods: {
    onSelectType(action) {
      this.repairType = action.value;
      this.showTypeSheet = false;
    },
    triggerPick() {
      this.$refs.fileInput && this.$refs.fileInput.click();
    },
    onFilesChange(e) {
      const files = Array.from(e.target.files || []);
      e.target.value = '';
      if (!files.length) return;
      const remain = this.maxImages - this.images.length;
      if (remain <= 0) {
        Toast(`最多上传${this.maxImages}张图片`);
        return;
      }
      const selected = files.slice(0, remain);
      if (files.length > remain) {
        Toast(`最多上传${this.maxImages}张图片`);
      }
      selected.forEach(file => {
        if (!file.type.startsWith('image/')) return;
        this.uploadImage(file);
      });
    },
    removeImage(index) {
      const [removed] = this.images.splice(index, 1);
      if (removed && removed.localUrl) URL.revokeObjectURL(removed.localUrl);
    },
    uploadImage(file) {
      const localUrl = URL.createObjectURL(file);
      const item = {
        key: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
        localUrl,
        url: localUrl,
        remoteUrl: '',
        uploading: true
      };
      this.images.push(item);

      const formData = new FormData();
      formData.append('files', file);
      this.axios.post('/qrcode/img_uploads', formData).then(res => {
        const body = res.data || {};
        const data = body.data;
        let remoteUrl = '';
        if (typeof data === 'string') {
          remoteUrl = data;
        } else if (data && data.src != null) {
          remoteUrl = Array.isArray(data.src) ? data.src[0] : data.src;
        } else if (data && data.url) {
          remoteUrl = data.url;
        }
        if (body.code !== 0 && body.code !== 200) {
          throw new Error(body.message || '图片上传失败');
        }
        if (!remoteUrl) {
          throw new Error(body.message || '图片上传失败');
        }
        item.remoteUrl = remoteUrl;
        item.uploading = false;
        if (item.localUrl) URL.revokeObjectURL(item.localUrl);
        item.localUrl = '';
        item.url = remoteUrl;
      }).catch(err => {
        const idx = this.images.indexOf(item);
        if (idx !== -1) this.images.splice(idx, 1);
        if (item.localUrl) URL.revokeObjectURL(item.localUrl);
        Toast((err && err.message) || '图片上传失败');
      });
    },
    async onSubmit() {
      const subCode = this.subCode;
      if (!subCode) {
        Toast('缺少分单编号');
        return;
      }
      if (!this.repairType) {
        Toast('请选择报修类型');
        return;
      }
      if (!this.description.trim()) {
        Toast('请填写问题描述');
        return;
      }
      if (!this.images.length) {
        Toast('请至少上传1张图片');
        return;
      }
      if (this.images.some(img => img.uploading)) {
        Toast('图片上传中，请稍候');
        return;
      }
      const picture = this.images.map(img => img.remoteUrl).filter(Boolean);
      if (!picture.length) {
        Toast('请至少上传1张图片');
        return;
      }
      if (this.submitting) return;

      this.submitting = true;
      Toast.loading({ message: '提交中...', forbidClick: true, duration: 0 });
      try {
        const res = await this.axios.post('/qrcode/after_sale_phone_add', {
          sub_code: subCode,
          type: this.repairType,
          describe: this.description.trim(),
          picture,
          phone: '',
          contacts_name: ''
        });
        const body = res.data || {};
        if (body.code === 0) {
          Toast.clear();
          Toast.success(body.message || '售后单添加成功');
          this.$router.replace({
            path: '/hl/info',
            query: { id: subCode }
          });
        } else {
          Toast.clear();
          Toast(body.message || '提交失败');
        }
      } catch (err) {
        Toast.clear();
        Toast((err && err.message) || '提交失败，请稍后重试');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.hl-repair {
  padding: 20px 16px 100px;
  text-align: left;
  background: #fff;
  min-height: 100vh;
  box-sizing: border-box;
}

.title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #222;
  margin: 8px 0 24px;
}

.type-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  gap: 10px;
}

.label {
  font-size: 14px;
  color: #333;
  white-space: nowrap;
}

.type-value {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  color: #333;
}

.type-value .placeholder {
  color: #999;
}

.arrow {
  color: #999;
}

.desc {
  width: 100%;
  box-sizing: border-box;
  min-height: 120px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  resize: none;
  font-family: inherit;
}

.images {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.thumb {
  position: relative;
  width: 72px;
  height: 72px;
  border-radius: 8px;
  overflow: hidden;
  background: #e8e8e8;
}

.thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.remove {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 14px;
  border-radius: 0 0 0 6px;
}

.add-btn {
  width: 72px;
  height: 72px;
  border: 1px dashed #bbb;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #1989fa;
  background: #f7f8fa;
  box-sizing: border-box;
}

.add-btn .cam {
  font-size: 20px;
  line-height: 1.2;
}

.submit {
  width: 70% !important;
  margin: 28px auto 0;
  display: block;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/hl-repair.vue